/* eslint-disable max-lines */
import Clipboard from "clipboard";
import clsx from "clsx";
import { FC, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "zenn-content-css";
import { Iframe } from "@/components/Iframe/Iframe";
import { CopyButton } from "./CopyButton/CopyButton";
import { EmbedCard } from "./EmbedCard/EmbedCard";
import { EmbedTweet } from "./EmbedTweet/EmbedTweet";

interface Props {
  markdown: string;
  bodyHtml: string;
}

export const Content: FC<Props> = ({ markdown, bodyHtml }) => {
  const [portals, setPortals] = useState<JSX.Element[]>([]);

  const initPortals = () => {
    setPortals([
      ...Array.from(
        document.querySelectorAll<HTMLDivElement>(
          "div.custom-embed-tweet, div.custom-embed-card, div.custom-embed-github",
        ),
      ).map((el, index) => {
        const url = el.querySelector("a")?.href ?? "";

        if (Array.from(el.classList).includes("custom-embed-tweet")) {
          return createPortal(<EmbedTweet url={url} />, el, `tweet-${index}`);
        }

        if (Array.from(el.classList).includes("custom-embed-github")) {
          return createPortal(
            <Iframe
              title={"Github"}
              src={`${window.location.origin}/embed/github?linkData=${encodeURIComponent(url)}`}
              className="max-h-[300px] w-full rounded-lg border border-gray-pale"
            />,
            el,
            `github-${index}`,
          );
        }

        return createPortal(<EmbedCard url={url} />, el, `card-${index}`);
      }),
      ...Array.from(document.querySelectorAll<HTMLDivElement>(".code-block-container")).map((el) => {
        return createPortal(
          <CopyButton
            onClick={() => {
              Clipboard.copy(el.innerText);
            }}
            tooltip="コピーされました!"
          />,
          el,
        );
      }),
    ]);
  };

  useEffect(() => {
    import("zenn-embed-elements");
    initPortals();
  }, [markdown]);

  useEffect(() => {
    const loadMermaid = async () => {
      if (markdown.includes("```mermaid")) {
        const { default: mermaid } = await import("mermaid");
        mermaid.initialize({});
        await mermaid.run();
      }
    };
    void loadMermaid();
  }, [markdown]);

  return (
    <>
      {portals}
      <div className={clsx("my-[48px] mt-[12px] p-0", "znc")} dangerouslySetInnerHTML={{ __html: bodyHtml }} />
    </>
  );
};
